
import React from 'react';
import CalendarLegend from '../ui-pending/CalendarLegend';
import type { CalendarLegendItem } from '../ui-pending/CalendarLegend';

// Swatches mirror the event colours calendar.tsx hands to FullCalendar (data, not tokens).
const LEGEND_ITEMS: CalendarLegendItem[] = [
  { label: 'Completed', color: '#7b7e80' },
  { label: 'Booked', color: '#FFC107' },
  // { label: 'No-Show', color: '#F44336' },
  { label: 'Free', color: '#bed197' },
  // { label: 'Group Slot', color: '#4e49e1' },
  { label: 'Special-Free Slot', color: 'palevioletred' },
  { label: 'Leave', color: '#ff5151' },
  { label: 'RnR/Showcase', color: '#e82c86' },
];

const Colorbox = () => {
    return <CalendarLegend items={LEGEND_ITEMS} label="Calendar legend" nowrap />;
};

export default Colorbox ;
